module.exports = __webpack_public_path__ + "f8a64a12fb59e8e35da0b266ff22e6f2.pdf";